if (!customElements.get("popup-modal")) {
  customElements.define(
    "popup-modal",
    class extends HTMLElement {
      connectedCallback() {
        const overlay = this.querySelector(".pt-popup-overlay");
        const container = this.querySelector(".pt-popup-container");
        const button = this.querySelector(".pt-popup-button");

        if (!overlay || !container) return;

        const storageKey = "popup-modal-shown-session";

        if (sessionStorage.getItem(storageKey)) return;

        const close = () => {
          overlay.classList.remove("active");
          container.classList.remove("active");
          document.body.style.overflow = "";
        };

        const open = () => {
          overlay.classList.add("active");
          container.classList.add("active");
          document.body.style.overflow = "hidden";

          sessionStorage.setItem(storageKey, "true");
        };

        button?.addEventListener("click", close);
        overlay?.addEventListener("click", close);

        const delay = (this.dataset.delay || 0) * 1000;

        setTimeout(open, delay);
      }
    },
  );
}
